module.exports = __webpack_public_path__ + "static/media/purple-play-icon.5ac9f73a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/purple-play-icon.svg
// module id = 467
// module chunks = 0